export default function yesNoFormatter(b) {
    return b ? 'Yes' : 'No';
}
